/* eslint-disable indent , no-nested-ternary */
const i18n = (...params) => window.Messages(...params);

export const template = ({ store, productInfo = {} }, storeIndex) => {
  // Template params
  const quantity = productInfo.quantity || 0;
  const CNC1h = productInfo.clickNcollect1h || false;
  const slice = store.open.current_slice;
  const userIsLoggued = cube.$('.js-user-status') && cube.$('.js-user-status').dataset.isLoggued === 'true';
  const redirectAfterLoginUrl = cube.$('.js-redirect-after-login').dataset.urlModelSize;
  const sellableOnline = cube.$('#sellableOnline') && cube.$('#sellableOnline').value === 'true';
  let ctaZone = '';

  if(window.storeFinderDrive) {
    if (sellableOnline) {
      ctaZone = `<button class="cta-v2 cta-v2--outline cta-v2--s js-select-store" data-icon=">" data-store-id="${ store.store_id }">
      ${i18n('storeselection.drive.selection')}
      </button>`;
    } else {
      ctaZone = `<span>${i18n('storeselection.drive.hazardous.product')}</span>`;
    }

  } else if (CNC1h) {
    if (userIsLoggued) {
      ctaZone = `<button class="cta-v2 cta-v2--s js-add-to-cart--cnc1h ${!sellableOnline ? 'disabled cta-v2--disabled' : ''}" data-icon=">" data-store-id="${ store.store_id }">
        ${i18n('storeselection.cnc1h.bookingcta')}
      </button>`;
    } else {
      ctaZone = `<span class='store-selection__login-invite js-login-and-redirect'>${i18n('storeselection.cnc1h.loginneeded', redirectAfterLoginUrl)}</span>`;
    }
  } else {
    ctaZone = `<span>${i18n('storeselection.cnc1h.bookingunavailable')}</span>`;
  }

  return `

  <li class="js-store-result store-selection__store ${
    quantity === 0 ? 'store-selection__store--disabled' : ''
  }" data-id-store="${store.store_id}">

    <h4>${storeIndex + 1} - ${store.name}</h4>

    ${
      quantity >= 1 /* Product has stock*/
        ? `<span class="store-selection__stock">
            <strong>${i18n('storeselection.cnc1h.instock')}</strong>
            ${CNC1h ? ` - ${i18n('storeselection.cnc1h.pickupmessage')}` : ''}
          </span>`
        : ''
    }

    <span class="store-selection__availability ${quantity < 1 ? 'store-selection__not-available' : ''}">
    ${
      quantity === 1
        ? i18n('storeselection.cnc1h.stock.quantity.singular')
        : quantity > 1
          ? i18n('storeselection.cnc1h.stock.quantity.plural', quantity)
          : i18n('storeselection.cnc1h.unavailable')
    }
    </span>

    ${
      store.open.open_now /* OPEN / CLOSE + current slice */
        ? `<span class="store-selection__hours">
        ${i18n('storeselection.storeOpeningHours', slice.start, slice.end)}
        </span>`
        : `<span class="store-selection__hours store-selection__hours--closed">
          ${i18n('storeselection.storeIsClosed')}
        </span>`
    }


    <div class="store-selection__cta-zone">
      ${ctaZone}
    </div>

  </li>`;
};



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/templates/template-click-n-collect.js